import axios from "./axios-config";

export const getAllGalleries = async (keyword, page) => {

    let { data } = await axios.get(`/super-admin/galleries?keywords=${keyword ?? ""}&page=${page}`)
    return (data);

}

export const getSingleGallery = async (id) => {

    let { data } = await axios.get(`/super-admin/galleries/` + id)
    return data;

}
export const deleteSingleGallery = async (id) => {
    let { data } = await axios.delete(`/super-admin/galleries/` + id)
    return data;
}
export const deleteSingleGalleryImage = async (postdata) => {
    let { data } = await axios.post(`/super-admin/galleries/delete-files/` + postdata.id,postdata.data)
    return data;
}

export const updateSingleGalleries = async (updateData) => {

    let { data } = await axios.post(`/super-admin/galleries/${updateData.id}?_method=put`, updateData.data)
    return data;
}

export const storeSingleGalleries = async (storeData) => {

    let { data } = await axios.post(`/super-admin/galleries`, storeData)
    return data
}


// export const getBlogGalleries = async (data) => {
//     let { data } =  await axios.post(`/super-admin/Galleries/all/galleries`, data)
//     return data;
// }

export const getWorkshopsWithoutGallery = async () => {
    try {
        let response = await axios.get(`/super-admin/workshops-without-gallery`)
        return (response.data);
    } catch (error) {
        return (error);
    }
}

